import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("caf_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return String(d);
}

export const timeLabel = (t) => {
  const h = parseInt(t?.split(":")[0], 10);
  return `${h % 12 || 12}:00 ${h < 12 ? "AM" : "PM"}`;
};

export const SLOT_GROUPS = [
  { name: "Overnight", hours: [0, 1, 2, 3, 4, 5, 6] },
  { name: "Morning", hours: [7, 8, 9, 10, 11] },
  { name: "Afternoon", hours: [12, 13, 14, 15, 16] },
  { name: "Evening", hours: [17, 18, 19, 20, 21] },
  { name: "Late night", hours: [22, 23] },
];

export const SERVICES = [
  { id: "res-standard", category: "residential", name: "Residential Standard Clean", blurb: "The weekly reset. Kitchens, baths, floors, surfaces — handled." },
  { id: "res-deep", category: "residential", name: "Residential Deep Clean", blurb: "Top to bottom, inside and out. The corners you forgot existed." },
  { id: "res-move", category: "residential", name: "Move In / Move Out Clean", blurb: "Hand the keys over spotless. Or walk into a fresh start." },
  { id: "com-office", category: "commercial", name: "Commercial Office Clean", blurb: "Desks, kitchens, restrooms, glass. Your team will notice." },
  { id: "com-retail", category: "commercial", name: "Retail & Showroom Clean", blurb: "Floors and displays that make customers stop and stare." },
  { id: "com-construction", category: "commercial", name: "Post-Construction Clean", blurb: "Dust, debris, residue. Gone before the ribbon cutting." },
];

export const IMG = {
  hero: "/images/img1.jpg",
  residential: "/images/img2.jpg",
  commercial: "/images/img3.jpg",
  office: "/images/img4.jpg",
  marble: "/images/img5.jpg",
  faucet: "/images/img6.jpg",
};
